/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { userRevokeInvitation } from '../../axios/userRevokeInvitation'
import type {
	UserRevokeInvitationError,
	UserRevokeInvitationRequest,
	UserRevokeInvitationResponse,
} from '../../types/UserRevokeInvitation'

export const userRevokeInvitationMutationKey = () => [{ url: '/invitations/revoke' }] as const

export type UserRevokeInvitationMutationKey = ReturnType<typeof userRevokeInvitationMutationKey>

export type UserRevokeInvitationVariables = {
	data: UserRevokeInvitationRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::revokeInvitation */
export function useUserRevokeInvitation<TContext = unknown>(
	options?: UseMutationOptions<
		UserRevokeInvitationResponse,
		AxiosError<UserRevokeInvitationError>,
		UserRevokeInvitationVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: userRevokeInvitationMutationKey(),
		mutationFn: ({ data }: UserRevokeInvitationVariables) =>
			userRevokeInvitation(data, config).then(res => res.data),
		...options,
	})
}
